// import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { StructuredText } from 'react-datocms'
import React from 'react';

import * as styles from './styles.module.css'
import Cta from '../CTA/index';

function HeroBlock({ headline, text, ctaText, url, index })
{
  return (
    <div
      className={
        styles.heroSection +
        "  relative z-10 p-4 md:p-16 md:pb-8 text-center text-white bg-opacity-90 mt-5 flex-grow-0 flex flex-col items-center"
        + (index === 0 ? " bg-orange md:items-end md:text-right" : " bg-blue md:items-start md:text-left")
      }
    >
      <h2 className=" font-medium text-2xl sm:text-4xl mb-8">{headline}</h2>
      <div className="font-light leading-7">
        <StructuredText data={text} />
      </div>
      <div className="flex-grow" />
      <Cta title={ctaText} url={url} className={index === 0 ? "bg-green" : "bg-opacity-30 bg-black"} />
    </div>
  )
}

function ContentHeroHome({ blocks })
{

  // const [heroItem1, heroItem2] = block.heroItem
  return (
    <div className={styles.hero + "  relative"} >
      <div className="absolute w-full h-full overflow-hidden z-0 hidden md:block">
        {/* <GatsbyImage image={getImage(block.backgroundImage)} style={{ width: "100%", height: "100%" }} objectFit="fill" objectPosition="50% 50%" /> */}
      </div>
      <div className="w-full h-full grid grid-cols-1 md:grid-cols-2">
        {blocks.map((block, index) => (
          <HeroBlock key={block.id} {...block} index={index} />
        ))}
        {/* <div className={styles.heroSection + "  relative z-10 p-4 md:p-16 md:pb-8 text-center md:text-right text-white bg-orange bg-opacity-90 mt-5 flex-grow-0 flex flex-col items-center md:items-end"}>
          <h2 className=" font-medium text-2xl sm:text-4xl mb-8">{heroItem1.headline}</h2>
          <div className="font-light leading-7">
            <StructuredText data={heroItem1.text} />
          </div>
          <div className="flex-grow" />
          <CTA title={heroItem1.cta.title} url={"/" + heroItem1.cta.url.slug} color="bg-green" />
        </div>
        <div className={styles.heroSection + "  relative z-10 p-4 md:p-16 md:pb-8 text-center md:text-left text-white bg-blue bg-opacity-90 mt-5 flex-grow-0 flex flex-col items-center md:items-start"}>
          <h2 className=" font-medium text-2xl sm:text-4xl mb-8">{heroItem2.headline}</h2>
          <div className="font-light leading-7">
            <StructuredText data={heroItem2.text} />
          </div>
          <div className="flex-grow" />
          <CTA title={heroItem2.cta.title} url={"/" + heroItem2.cta.url.slug} color="bg-opacity-30 bg-black" />
        </div> */}
      </div>
    </div>
  );
}

export default ContentHeroHome;